import { apiGet, apiPost, apiPut, throwApiError } from "../utils";

export const login = async (data) => {
  const response = await apiPost("/auth/admin/login", data);
  const { message, ...user } = await response.json();

  throwApiError(message, {
    map: { invalid_email_or_password: "Invalid credentials" },
  });

  return user;
};

export const getUsers = async (page, perPage, search = "") => {
  const response = await apiGet("/admin/users", { page, perPage, search });
  const { items, totalCount, message } = await response.json();

  throwApiError(message);

  return { items, totalCount };
};

export const getUserById = async (id) => {
  const response = await apiGet(`/admin/users/${id}`);
  const { message, ...report } = await response.json();

  throwApiError(message);

  return report;
};

export const updateUserRole = async (id, action) => {
  const response = await apiPut(`/admin/users/${id}/${action}`);
  const { message, ...report } = await response.json();

  throwApiError(message);

  return report;
};

export const downloadUsers = async () => {
  const response = await apiGet("/admin/download-csv");
  if (response.status !== 200) {
    alert("Error downloading users!");
    return;
  }

  const url = await response.text();
  window.open(url, "_blank");

  return url;
};
